import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {environment} from "../../environments/environment";
import {FinalResponse} from "../model/responses/finalResponse";
import {SmsSenderRequest} from "../model/requests/SmsSenderRequest";

const BASE_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root'
})
export class SmsSenderService {

  constructor(private httpClient: HttpClient) {
  }

  public async functionSmsSend(body: SmsSenderRequest, observe: any = 'body', reportProgress = false): Promise<FinalResponse | undefined> {
    return await firstValueFrom(
      this.httpClient.request<FinalResponse>('post', `${BASE_URL}/api/sms`, {
        body: body,
        observe: 'body', // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
        reportProgress: reportProgress
      })
    );
  }

  public async functionGetConfigSms(observe: any = 'body', reportProgress = false): Promise<any> {
    return await firstValueFrom(
      this.httpClient.request<FinalResponse>('get', `${BASE_URL}/api/sms-config`, {
        body: {},
        observe: 'body', // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
        reportProgress: reportProgress
      })
    );
  }

}
